import { ApolloClient, InMemoryCache } from '@apollo/client'

import link from './link'

const cache = new InMemoryCache({
  addTypename: false
})

const client = new ApolloClient({
  link,
  cache
})

export { client }
